import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import lupaIcon from '../assets/lupita.png';

// La función para obtener el título se mantiene igual
const getTitle = (pathname) => {
  switch (pathname) {
    case '/':
      return 'Dashboard';
    case '/mercado/comprar-vender':
      return 'Comprar y Vender';
    case '/mercado/estado-xcoin':
      return 'Estado XCoin';
    case '/billetera/balance':
      return 'Balance y Movimientos';
    case '/billetera/depositar-retirar':
      return 'Depósitos, Retiros y Movimientos en CLP';
    case '/graficos':
      return 'Gráficos';
    case '/perfil':
      return 'Mi Perfil';
    case '/noticias':
      return 'Noticias';
    default:
      return 'Dashboard';
  }
};

// --- Mapa de páginas con palabras clave para la búsqueda ---
const searchablePages = [
  { path: '/', title: 'Dashboard', keywords: ['inicio', 'principal', 'resumen', 'saldo'] },
  { path: '/mercado/comprar-vender', title: 'Comprar y Vender', keywords: ['trading', 'mercado', 'comprar', 'vender', 'btc', 'eth', 'xcn'] },
  { path: '/mercado/estado-xcoin', title: 'Estado XCoin', keywords: ['token', 'ico', 'venta'] },
  { path: '/billetera/balance', title: 'Balance y Movimientos', keywords: ['billetera', 'activos', 'movimientos', 'saldo'] },
  { path: '/billetera/depositar-retirar', title: 'Depósitos, Retiros y Movimientos en CLP', keywords: ['depositar', 'retirar', 'banco', 'transferencia', 'wallet', 'clp', 'pesos'] },
  { path: '/graficos', title: 'Gráficos', keywords: ['analisis', 'portafolio', 'estadisticas', 'rendimiento'] },
  { path: '/noticias', title: 'Noticias', keywords: ['actualidad', 'novedades', 'mercado'] },
  { path: '/perfil', title: 'Mi Perfil', keywords: ['configuracion', 'cuenta', 'usuario', 'seguridad'] },
];

// Nuevos imports para funcionalidad de usuario en móvil
import { useUser } from '../contexts/UserContext';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';

const Header = ({ toggleSidebar, isMobile }) => {
  const location = useLocation();
  const title = getTitle(location.pathname);

  // Contextos para móvil
  const { userData } = useUser();
  const { theme, toggleTheme } = useContext(ThemeContext);

  // --- Estados para manejar la lógica de la búsqueda ---
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchTerm(query);

    if (query.length > 1) {
      const lowerCaseQuery = query.toLowerCase();
      const results = searchablePages.filter(page =>
        page.title.toLowerCase().includes(lowerCaseQuery) ||
        page.keywords.some(keyword => keyword.toLowerCase().includes(lowerCaseQuery))
      );
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  };

  const handleResultClick = () => {
    // Limpia la búsqueda al hacer clic en un resultado
    setSearchTerm('');
    setSearchResults([]);
  };

  return (
    <header className="header">
      <div className="header-left">
        {/* Botón hamburguesa visible siempre que la props lo permita (controlado por CSS display en desktop) */}
        <button onClick={toggleSidebar} className="sidebar-toggle-btn">
          <span>&#9776;</span>
        </button>
        <h1>{title}</h1>
      </div>

      {/* Barra de búsqueda (puedes ocultarla en móvil con CSS si molesta, o dejarla) */}
      <div className="search-bar" style={isMobile ? { display: 'none' } : {}}>
        <img src={lupaIcon} alt="Buscar" className="search-icon" />
        <input
          id="dashboard-search"
          name="search"
          type="text"
          placeholder="Buscar aquí..."
          value={searchTerm}
          onChange={handleSearchChange}
          autoComplete="off"
        />
        {searchResults.length > 0 && (
          <ul className="search-results">
            {searchResults.map(page => (
              <li key={page.path}>
                <Link to={page.path} onClick={handleResultClick}>
                  {page.title}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Controles de Usuario para Móvil (Reemplazo de RightSidebar) */}
      {isMobile && (
        <div className="mobile-user-controls" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          {/* Toggle Tema (Pequeño) */}
          <button onClick={toggleTheme} style={{ background: 'none', border: 'none', fontSize: '1.2rem' }}>
            {theme === 'dark' ? 'Claro' : 'Oscuro'}
          </button>

          {/* Avatar (Link directo a perfil) */}
          <Link to="/perfil" style={{ display: 'block' }}>
            <img
              src={userData?.avatarUrl || '../assets/default-avatar.png'}
              alt="Avatar"
              style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover', border: '2px solid var(--border-color)' }}
            />
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;